import {html, LitElement} from 'lit';
import {customElement, state, property} from 'lit/decorators.js';
import {unsafeHTML} from 'lit/directives/unsafe-html.js';
import {TariffFormStore} from './../Storage/tariffStorage';

import './FormElements/swsFormHeader';

@customElement('sws-delivery')
export class swsDelivery extends LitElement {

    @property({type: Array})
    tabs: { id: string; title: string; data: any; deliveryData?: Record<string, any> }[]

    @property({type: String})
    selectedReason: string = 'supplier-change';

    @property({type: String})
    selectedSwitchMeterNumber: string = 'know-meter-number';

    @property({type: Array})
    gasSupplier = [];

    @property({type: Array})
    electricitySupplier = [];

    protected createRenderRoot() {
        return this;
    }

    connectedCallback() {
        super.connectedCallback();

        window.addEventListener('tariffs-current', this._buildHeadFromTariffs.bind(this));

        document.addEventListener('tariff-updated-temporary', this.handleTariffUpdatedTemporary.bind(this));
        window.addEventListener('tariff-clear-tabs', this.handleClearTabs.bind(this));
        document.addEventListener('tariff-deleted', this.deleteTariff.bind(this));
    }

    private _buildHeadFromTariffs(e: CustomEvent) {
        const selectedTariffs = e.detail as Tariff[];
        this.tabs = selectedTariffs.map((tariff, index) => ({
            id: `tab-${index}`,
            title: tariff.tariff.title,
            data: tariff,
            deliveryData: {
                selectedReason: this.selectedReason,
                selectedTerminationType: 'sws',
                alreadyResigned: false,
                terminateContractBySWS: true,
                selectedSwitchMeterNumber: this.selectedSwitchMeterNumber,
            }
        }));

        selectedTariffs.forEach((t, i) => {
        });
    }

    deleteTariff(e: CustomEvent) {

        this.tabs.forEach((tab, index) => {
            if (tab.id === e.detail.tariffUid) {
                this.tabs.splice(index, 1); // Entferne den Tab
            }
        });

        this.requestUpdate();
    }

    handleTariffUpdatedTemporary(e: CustomEvent) {
        const updatedTariff = e.detail.updatedTariff;

        // Suchen des betroffenen Tarifs anhand der ID
        const tabIndex = this.tabs.findIndex(t => t.data.tariff.id === updatedTariff.tariff.id);
        if (tabIndex === -1) {
            console.warn('Kein passender Tarif gefunden zum Überschreiben.');
            return;
        }

        const existingTab = this.tabs[tabIndex];

        const newTab = {
            ...existingTab,
            data: updatedTariff,
            deliveryData: existingTab.deliveryData
        };

        this.tabs = [
            ...this.tabs.slice(0, tabIndex),
            newTab,
            ...this.tabs.slice(tabIndex + 1)
        ];

        this._dispatchTariffs();
    }

    private handleClearTabs(e: CustomEvent) {
        const idsToRemove = e.detail as string[];

        if (!idsToRemove || idsToRemove.length === 0) {
            // Wenn kein Eintrag: lösche alles
            this.tabs = [];
        } else {
            // Nur bestimmte Tabs löschen
            this.tabs = this.tabs.filter(tab => !idsToRemove.includes(tab.data.tariff.id));
        }

        this.requestUpdate();
        this._dispatchTariffs();
    }

    private _validateDeliveryForm(): boolean {

        const allInvalidFeedbacks = this.renderRoot.querySelectorAll('.invalid-feedback');
        const allInvalidClasses = this.renderRoot.querySelectorAll('.is-invalid');
        const allValidClasses = this.renderRoot.querySelectorAll('.is-invalid');
        allInvalidFeedbacks.forEach((el) => {
            el.textContent = '';
            (el as HTMLElement).classList.add('d-none');

        });
        allInvalidClasses.forEach((el) => {
            el.classList.remove('is-invalid')
        });
        allValidClasses.forEach((el) => {
            el.classList.remove('is-valid')
        });

        let valid = true;
        const existingTariffs = TariffFormStore.get('allTariffs') || [];

        const meterCounts: Record<string, number> = {};
        const maloCounts: Record<string, number> = {};

        this.tabs.forEach((t: any) => {
            if (t.deliveryData.selectedSwitchMeterNumber === 'know-meter-number') {
                const meter = t.deliveryData?.allMeterCounter?.trim();
                const malo = t.deliveryData?.maloCounter?.trim();

                if (meter) meterCounts[meter] = (meterCounts[meter] || 0) + 1;
                if (malo) maloCounts[malo] = (maloCounts[malo] || 0) + 1;

                const currentMeter = meter;
                const sameMeter = currentMeter
                    ? existingTariffs.filter((t: any) =>
                        t.deliveryData.allMeterCounter === currentMeter
                    )
                    : [];

                const meterDuplicateInTabs = currentMeter && meterCounts[currentMeter] > 1;

                const currentMalo = t.deliveryData?.maloCounter?.trim();
                const sameMalo = currentMalo
                    ? existingTariffs.filter((t: any) =>
                        t.deliveryData.maloCounter === currentMalo
                    )
                    : [];
                const maloDuplicateInTabs = currentMalo && maloCounts[currentMalo] > 1;

                if (t.data.type === 2) {
                    const meterInput = this.renderRoot.querySelector(`#sws-rateCalculator-electricity-meter`) as HTMLInputElement;
                    const group = this.renderRoot.querySelector(`.input-group-icon-el`) as HTMLElement;
                    const groupFeedback = this.renderRoot.querySelector(`#feedback-electricity`) as HTMLElement;
                    const groupFeedback1 = this.renderRoot.querySelector(`#feedback-electro-malo`) as HTMLElement;
                    const maloInput = this.renderRoot.querySelector(`#sws-rateCalculator-electricity-malo-number`) as HTMLInputElement;
                    const hasMeterValue = meterInput && meterInput.value.trim() !== '';
                    const hasMaloValue = maloInput && maloInput.value.trim() !== '';

                    if (!hasMeterValue && !hasMaloValue) {
                        // Beide leer → Fehler
                        if (meterInput) this._setInvalid(meterInput, '');
                        if (group) this._setInvalid(group, '');
                        if (maloInput) this._setInvalid(maloInput, '');
                        if (groupFeedback1) this._setInvalid(groupFeedback1, `${TYPO3?.lang?.[`validation.delivery.counter.electricity.empty`]}`);
                        valid = false;
                    } else {
                        if ((sameMeter.length >= 1 || meterDuplicateInTabs) || (sameMalo.length >= 1 || maloDuplicateInTabs)) {
                            if (sameMeter.length >= 1 || meterDuplicateInTabs) {
                                // Fehler: Zähler/MaLo bereits vorhanden
                                if (groupFeedback) this._setInvalid(groupFeedback, TYPO3?.lang?.[`validation.delivery.counter.electricity.double`]);
                                if (group) this._setInvalid(group, '');
                                if (meterInput) this._setInvalid(meterInput, '');
                                valid = false;
                            }
                            if (sameMalo.length >= 1 || maloDuplicateInTabs) {
                                if (maloInput) this._setInvalid(maloInput, '');
                                if (groupFeedback1) this._setInvalid(groupFeedback1, TYPO3?.lang?.['validation.delivery.counter.maloCounter.double']);
                                valid = false;
                            }
                        } else {
                            if (hasMeterValue && hasMaloValue) {
                                if (meterInput) this._setValid(meterInput);
                                if (group) this._setValid(group);
                                if (maloInput) this._setValid(maloInput);
                            } else if (hasMeterValue) {
                                if (meterInput) this._setValid(meterInput);
                                if (group) this._setValid(group);
                            } else {
                                if (maloInput) this._setValid(maloInput);
                            }
                        }
                    }

                    if (t.title === "ÖkostromDyna") {

                        const groupSmartMeter = this.renderRoot.querySelector(`.feedback-border-smartMeter-${t.id}`) as HTMLElement;
                        const terminationFeedback = this.renderRoot.querySelector(`#termination-feedback-smartMeter-${t.id}`) as HTMLElement;
                        if (!t.deliveryData?.smartMeterOption) {
                            this._setInvalid(groupSmartMeter, '')
                            valid = false;
                            if (terminationFeedback) {
                                terminationFeedback.textContent = TYPO3?.lang?.['validation.delivery.smartMeter.empty'];
                                terminationFeedback.classList.remove('d-none');
                                terminationFeedback.classList.add('d-block');
                            }
                        } else {
                            this._setValid(groupSmartMeter)
                        }
                    }

                } else if (t.data.type === 1) {
                    const group1Feedback = this.renderRoot.querySelector(`#feedback-heatPump`) as HTMLElement;
                    const group1 = this.renderRoot.querySelector(`.input-group-icon-hp`) as HTMLElement;
                    const heatMeterInput = this.renderRoot.querySelector(`#sws-rateCalculator-heatPump-meter`) as HTMLInputElement;
                    const group1Feedback1 = this.renderRoot.querySelector(`#feedback-heat-malo`) as HTMLElement;
                    const heatMaloInput = this.renderRoot.querySelector(`#sws-rateCalculator-heatPump-malo-number`) as HTMLInputElement;

                    const hasMeterValue = heatMeterInput && heatMeterInput.value.trim() !== '';
                    const hasMaloValue = heatMaloInput && heatMaloInput.value.trim() !== '';

                    if (!hasMeterValue && !hasMaloValue) {
                        // Beide leer → Fehler
                        if (heatMeterInput) this._setInvalid(heatMeterInput, '');
                        if (group1) this._setInvalid(group1, '');
                        if (heatMaloInput) this._setInvalid(heatMaloInput, '');
                        if (group1Feedback1) this._setInvalid(group1Feedback1, `${TYPO3?.lang?.[`validation.delivery.counter.electricity.empty`]}`);
                        valid = false;
                    } else {
                        if ((sameMeter.length >= 1 || meterDuplicateInTabs) || (sameMalo.length >= 1 || maloDuplicateInTabs)) {
                            if (sameMeter.length >= 1 || meterDuplicateInTabs) {
                                // Fehler: Zähler/MaLo bereits vorhanden
                                if (group1Feedback) this._setInvalid(group1Feedback, TYPO3?.lang?.[`validation.delivery.counter.electricity.double`]);
                                if (heatMeterInput) this._setInvalid(group1, '');
                                if (group1) this._setInvalid(group1, '');
                                valid = false;
                            }
                            if (sameMalo.length >= 1 || maloDuplicateInTabs) {
                                if (heatMaloInput) this._setInvalid(heatMaloInput, '');
                                if (group1Feedback1) this._setInvalid(group1Feedback1, TYPO3?.lang?.['validation.delivery.counter.maloCounter.double']);
                                valid = false;
                            }
                        } else {
                            if (hasMeterValue && hasMaloValue) {
                                if (heatMeterInput) this._setValid(heatMeterInput);
                                if (group1) this._setValid(group1);
                                if (heatMaloInput) this._setValid(heatMaloInput);
                            } else if (hasMeterValue) {
                                if (heatMeterInput) this._setValid(heatMeterInput);
                                if (group1) this._setValid(group1);
                            } else {
                                if (heatMaloInput) this._setValid(heatMaloInput);
                            }
                        }
                    }

                } else { // Gas
                    const group2Feedback = this.renderRoot.querySelector(`#feedback-naturalGas`) as HTMLElement;
                    const group2Feedback2 = this.renderRoot.querySelector(`#feedback-gas-malo`) as HTMLElement;
                    const group2 = this.renderRoot.querySelector(`.input-group-icon-ng`) as HTMLElement;
                    const gasMeterInput = this.renderRoot.querySelector(`#sws-rateCalculator-gas-meter`) as HTMLInputElement;
                    const gasMaloInput = this.renderRoot.querySelector(`#sws-rateCalculator-naturalGas-malo-number`) as HTMLInputElement;

                    const hasMeterValue = gasMeterInput && gasMeterInput.value.trim() !== '';
                    const hasMaloValue = gasMaloInput && gasMaloInput.value.trim() !== '';

                    if (!hasMeterValue && !hasMaloValue) {
                        if (group2) this._setInvalid(group2, '');
                        if (gasMeterInput) this._setInvalid(gasMeterInput, '');
                        if (gasMaloInput) this._setInvalid(gasMaloInput, '');
                        if (group2Feedback2) this._setInvalid(group2Feedback2, TYPO3?.lang?.[`validation.delivery.counter.naturalGas.empty`]);
                        valid = false;
                    } else {
                        if ((sameMeter.length >= 1 || meterDuplicateInTabs) || (sameMalo.length >= 1 || maloDuplicateInTabs)) {
                            if (sameMeter.length >= 1 || meterDuplicateInTabs) {
                                if (group2Feedback) this._setInvalid(group2Feedback, TYPO3?.lang?.[`validation.delivery.counter.electricity.double`]);
                                if (group2) this._setInvalid(group2, '');
                                if (gasMeterInput) this._setInvalid(gasMeterInput, '');
                                valid = false;
                            }
                            if (sameMalo.length >= 1 || maloDuplicateInTabs) {
                                if (gasMaloInput) this._setInvalid(gasMaloInput, '');
                                if (group2Feedback2) this._setInvalid(group2Feedback2, TYPO3?.lang?.['validation.delivery.counter.maloCounter.double']);
                                valid = false;
                            }
                        } else {

                            if (hasMeterValue && hasMaloValue) {
                                if (gasMeterInput) this._setValid(gasMeterInput);
                                if (group2) this._setValid(group2);
                                if (gasMaloInput) this._setValid(gasMaloInput);
                            } else if (hasMeterValue) {
                                if (gasMeterInput) this._setValid(gasMeterInput);
                                if (group2) this._setValid(group2);
                            } else {
                                if (gasMaloInput) this._setValid(gasMaloInput);
                            }
                        }
                    }
                }
            }

            // Lieferantenwechsel oder Umzug prüfen
            if (this.selectedReason === 'supplier-change') {

                const supplierSelect = this.renderRoot.querySelector(`#sws-rateCalculator-supplier-change-supplier-${t.id}`) as HTMLSelectElement;
                if (!supplierSelect || !supplierSelect.value.trim()) {
                    this._setInvalid(supplierSelect, TYPO3?.lang?.[`validation.delivery.supplier.empty`]);
                    valid = false;
                } else {
                    this._setValid(supplierSelect);
                }

                // Validierung, ob Kündigungsart ausgewählt wurde
                const selectedTermination = t.deliveryData?.selectedTerminationType;
                const group4 = this.renderRoot.querySelector(`.feedback-border-${t.id}`) as HTMLElement;
                const terminationFeedback = this.renderRoot.querySelector(`#termination-feedback-${t.id}`) as HTMLElement;

                if (!selectedTermination) {
                    this._setInvalid(group4, '')
                    valid = false;
                    if (terminationFeedback) {
                        terminationFeedback.textContent = TYPO3?.lang?.['validation.delivery.cancelContract.empty'];
                        terminationFeedback.classList.remove('d-none');
                        terminationFeedback.classList.add('d-block');
                    }
                } else {
                    const selfTermination = this.renderRoot.querySelector(`#termination-self-${t.id}`) as HTMLInputElement;

                    if (selfTermination && selfTermination.checked) {
                        const resignDate = this.renderRoot.querySelector(`#resign-date-self-${t.id}`) as HTMLInputElement;
                        if (!resignDate || !resignDate.value.trim()) {
                            this._setInvalid(resignDate, TYPO3?.lang?.['validation.delivery.cancelContractDate.empty']);
                            valid = false;
                        } else {
                            this._setValid(resignDate);
                        }
                    } else {
                        this._setValid(group4)
                    }
                }

            } else if (this.selectedReason === 'move') {
                const moveDate = this.renderRoot.querySelector(`#sws-rateCalculator-electricity-on-key-handover`) as HTMLInputElement;
                if (!moveDate || !moveDate.value.trim()) {
                    this._setInvalid(moveDate, TYPO3?.lang?.[`validation.delivery.keyHandoverDate.empty`] || 'Bitte wählen Sie eine Kündigungsoption aus.');
                    valid = false;
                } else {
                    this._setValid(moveDate);
                }
            }
        });

        if (!valid) {
            // Zum ersten invaliden Feld scrollen und fokussieren
            const firstInvalid = this.querySelector('.is-invalid') as HTMLElement;
            if (firstInvalid) {
                firstInvalid.scrollIntoView({behavior: 'smooth', block: 'center'});
                firstInvalid.focus({preventScroll: true});
            }
        }
        return valid;
    }

    private _setInvalid(element: HTMLElement, message: string) {
        element.classList.add('is-invalid');
        element.classList.remove('is-valid');

        const feedback = element.closest(`.form-floating, .input-group, .form-check, #feedback-electricity, #feedback-electro-malo, #feedback-heatPump, #feedback-heat-malo, #feedback-naturalGas, #feedback-gas-malo, #suplier-change-feedback`)?.querySelector('.invalid-feedback') as HTMLElement;

        if (feedback) {
            feedback.textContent = message;
            feedback.classList.remove('d-none');
            feedback.classList.add('d-block');
        }
    }

    private _setValid(element: HTMLElement) {
        element.classList.remove('is-invalid');
        element.classList.add('is-valid');

        const feedback = element.closest('.form-floating, .input-group, .form-check, #feedback-electricity, #feedback-electro-malo, #feedback-heatPump, #feedback-heat-malo, #feedback-naturalGas, #feedback-gas-malo, #suplier-change-feedback')?.querySelector('.invalid-feedback') as HTMLElement;

        if (feedback) {
            feedback.textContent = '';
            feedback.classList.add('d-none');
        }
    }

    private _handleReasonChange(value: string) {
        this.selectedReason = value;
        this._updateAllTariffs('selectedReason', value);
    }

    private _dispatchTariffs() {
        this.dispatchEvent(new CustomEvent('tariffs-live-update', {
            detail: this.tabs,
            bubbles: true,
            composed: true
        }));
    }

    private _updateDeliveryData(tabId: string, key: string, value: any) {
        const tabIndex = this.tabs.findIndex(t => t.id === tabId);
        if (tabIndex === -1) return;

        const tab = this.tabs[tabIndex];
        const updatedDeliveryData = {
            ...tab.deliveryData,
            [key]: value
        };

        this.tabs = [
            ...this.tabs.slice(0, tabIndex),
            {...tab, deliveryData: updatedDeliveryData},
            ...this.tabs.slice(tabIndex + 1)
        ];

        this._dispatchTariffs()
    }


    private _updateAllTariffs(key: string, value: any) {
        this.tabs = this.tabs.map(tab => {
            return {
                ...tab,
                deliveryData: {
                    ...(tab.deliveryData || {}),
                    [key]: value
                }
            };
        });
        this._dispatchTariffs()
    }

    private _getMinDate(): string {
        const today = new Date();
        today.setDate(today.getDate() + 3);
        return today.toISOString().split('T')[0];
    }

    private _getMaxDate(): string {
        const maxDate = new Date();
        maxDate.setFullYear(maxDate.getFullYear() + 1);
        return maxDate.toISOString().split('T')[0];
    }

    private _isFormComplete(customerType: string): boolean {

        const requiredUserDataFields = [
            'sws-rateCalculator-contact-details-birthday',
            'sws-rateCalculator-contact-details-mail',
            'sws-rateCalculator-contact-details-street',
            'sws-rateCalculator-contact-details-house-number',
            'sws-rateCalculator-contact-details-postal-code',
            'sws-rateCalculator-contact-details-city'
        ];

        if (customerType === '0') {
            const requiredPrivateFields = [
                'sws-rateCalculator-contact-details-salutation',
                'sws-rateCalculator-contact-details-first-name',
                'sws-rateCalculator-contact-details-last-name',
            ]

            if (document.getElementById('sws-rateCalculator-billing-direct-debit-mandate').checked) {
                const requiredPaymentFields = [
                    'sws-rateCalculator-billing-details-cc-name',
                    'sws-rateCalculator-billing-details-cc-number',
                    'sws-rateCalculator-billing-details-cc-type',
                ]

                const allFields = [...requiredPrivateFields, ...requiredUserDataFields, ...requiredPaymentFields];

                return allFields.every(id => {
                    const el = document.getElementById(id) as HTMLInputElement;
                    return el && el.value.trim() !== '';
                });
            } else {
                const allFields = [...requiredPrivateFields, ...requiredUserDataFields];

                return allFields.every(id => {
                    const el = document.getElementById(id) as HTMLInputElement;
                    return el && el.value.trim() !== '';
                });
            }
        } else {
            const requiredCommercialFields = [
                'sws-rateCalculator-contact-details-company',
            ]

            if (document.getElementById('sws-rateCalculator-billing-direct-debit-mandate').checked) {
                const requiredPaymentFields = [
                    'sws-rateCalculator-billing-details-cc-name',
                    'sws-rateCalculator-billing-details-cc-number',
                    'sws-rateCalculator-billing-details-cc-type',
                ]

                const allFields = [...requiredCommercialFields, ...requiredUserDataFields, ...requiredPaymentFields];

                return allFields.every(id => {
                    const el = document.getElementById(id) as HTMLInputElement;
                    return el && el.value.trim() !== '';
                });
            } else {
                const allFields = [...requiredCommercialFields, ...requiredUserDataFields];

                return allFields.every(id => {
                    const el = document.getElementById(id) as HTMLInputElement;
                    return el && el.value.trim() !== '';
                });
            }
        }
    }


    private _handleNextStep() {
        let latestTabs = this.tabs;

        if (this._validateDeliveryForm()) {

            if (this._isFormComplete(latestTabs[0].data.tariff.meta.customerType)) {
                // Speicher den Tarif direkt, weil alles ausgefüllt ist
                const existingTariffs = TariffFormStore.get('allTariffs') || [];
                const updatedStore = [...existingTariffs, ...latestTabs];
                TariffFormStore.set('allTariffs', updatedStore);

                document.dispatchEvent(new CustomEvent('tariff-clear-tabs', {
                    detail: [],
                    bubbles: true,
                    composed: true
                }));

                const tariffTab = document.getElementById('tariff-tab') as HTMLElement;
                tariffTab.setAttribute('disabled', 'true');
                const deliveryTab = document.getElementById('delivery-tab') as HTMLElement;
                deliveryTab.setAttribute('disabled', 'true')
                const verifyTab = document.getElementById('verify-tab') as HTMLElement;

                if (verifyTab) {
                    const swsSummaryEl = document.querySelector('sws-summary') as any;
                    if (swsSummaryEl && typeof swsSummaryEl.updateElement === 'function') {
                        swsSummaryEl.updateElement(); // ✅ Triggert das Update
                    }
                    const userDataTab = document.getElementById('user-data-tab') as HTMLElement;
                    const paymentTab = document.getElementById('payment-tab') as HTMLElement;

                    document.getElementById('delivery-tab')?.classList.add('ready');
                    document.getElementById('payment-tab')?.classList.add('ready', 'op-100');
                    document.getElementById('user-data-tab')?.classList.add('ready', 'op-100');
                    userDataTab.removeAttribute('disabled');
                    paymentTab.removeAttribute('disabled');
                    document.getElementById('tariff-tab')?.classList.remove('op-100');
                    document.getElementById('tariff-tab')?.setAttribute('disabled', 'true');
                    document.getElementById('delivery-tab')?.setAttribute('disabled', 'true');

                    verifyTab.removeAttribute('disabled');
                    verifyTab.click();
                    this.tabs = [];
                    latestTabs = [];
                }
            } else {
                // Nur weiter zur UserData-Seite
                const userDataTab = document.getElementById('user-data-tab') as HTMLElement;
                if (userDataTab) {
                    document.getElementById('delivery-tab')?.classList.add('ready', 'op-100');
                    userDataTab.removeAttribute('disabled');
                    userDataTab.click();
                }
            }

            window.scrollTo({top: 0, behavior: 'smooth'});
        }
    }


    protected render() {
        return html`
            <div class="bg-gradient-sws">
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-12 col-lg-8 my-md-4">
                            <div class="bg-light-dark p-3-75 pt-2-375 pb-2-375">
                                <h2>${TYPO3?.lang?.['form.configureTariff.tabs.delivery.label']}</h2>
                                <sws-form-header></sws-form-header>

                            </div>

                            <div class="custom-fluid-content">
                                ${unsafeHTML(TYPO3?.lang?.['form.configureTariff.tabs.delivery.customHtmlContent'])}
                            </div>

                            <div class="bg-white p-3-75 pt-2-375 pb-2 m-auto">
                                <div class="pb-2-375">
                                    <p>${TYPO3?.lang?.['form.configureTariff.delivery.infoText']}</p>
                                </div>

                                <div class="d-flex flex-wrap" role="radiogroup"
                                     aria-label="${TYPO3?.lang?.['form.configureTariff.delivery.reason.ariaLabel']}">
                                    ${this.renderDeliveryReasonRadioOption('supplier-change', 'supplierChange', true)}
                                    ${this.renderDeliveryReasonRadioOption('move', 'move')}
                                </div>

                                ${this.selectedReason === 'supplier-change' ? html`
                                    ${this.tabs?.map(tariff => html`
                                        ${(tariff.data.type == 2) ? html`
                                            ${this.renderElectricityCounter(tariff)}
                                            ${tariff.title == "ÖkostromDyna" ? html`
                                                ${this.renderElectricitySmartMeter(tariff)}` : html``}
                                            ${this.renderSupplierChangeSection(tariff)}
                                            <div class="form-line mt-5"></div>
                                        ` : tariff.data.type == 1 ? html`
                                            ${this.renderHeatPumpCounter(tariff)}
                                            ${this.renderSupplierChangeSection(tariff)}
                                            <div class="form-line mt-5"></div>
                                        ` : html`${this.renderGasCounter(tariff)}
                                        ${this.renderSupplierChangeSection(tariff)}
                                        <div class="form-line mt-5"></div>
                                        `}`)}

                                ` : html` ${this.renderMoveSection()}
                                ${this.tabs?.map(tariff => html`
                                    ${tariff.data.type == 2 ? html`
                                        ${this.renderElectricityCounter(tariff)}
                                        ${tariff.title == "ÖkostromDyna" ? html`
                                            ${this.renderElectricitySmartMeter(tariff)}` : html``}
                                        <div class="form-line mt-5"></div>
                                    ` : tariff.data.type == 1 ? html`
                                        ${this.renderHeatPumpCounter(tariff)}
                                        <div class="form-line mt-5"></div>
                                    ` : html`${this.renderGasCounter(tariff)}
                                    <div class="form-line mt-5"></div>`}`)}`}

                                ${this.renderMoveNextPage()}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }

    private renderDeliveryReasonRadioOption(id: string, labelKey: string, checked = false) {
        return html`
            <div class="d-flex align-items-center gap-2 sws-radio-button border rounded-pill px-3 py-2 me-2 mb-2">
                <input
                        type="radio"
                        class="form-check-input mt-0"
                        name="delivery-reason"
                        id="${id}"
                        value="${id}"
                        ?checked=${this.selectedReason === id}
                        @change=${(e: Event) => this._handleReasonChange((e.target as HTMLInputElement).value)}
                />
                <label class="form-check-label fw-semibold" for="${id}">
                    ${TYPO3?.lang?.[`form.configureTariff.delivery.reason.${labelKey}`]}
                </label>
            </div>
        `;
    }

    private renderSwitchMeterNumberRadioOption(tariff: any, id: string, labelKey: string, checked = false) {
        return html`
            <div class="d-flex align-items-center gap-2 sws-radio-button border rounded-pill px-3 py-2 me-2 mb-2">
                <input
                        type="radio"
                        class="form-check-input mt-0"
                        name="switch-meter-number-${tariff.id}"
                        id="${id}-${tariff.id}"
                        value="${id}"
                        ?checked=${tariff.deliveryData.selectedSwitchMeterNumber === id || checked == true}
                        @change=${(e: Event) => this._updateDeliveryData(tariff.id, 'selectedSwitchMeterNumber', (e.target as HTMLInputElement).value)}
                />
                <label class="form-check-label fw-semibold" for="${id}-${tariff.id}">
                    ${TYPO3?.lang?.[`form.configureTariff.delivery.switchMeterNumber.${labelKey}`]}
                </label>
            </div>
        `;
    }

    private renderSwitchMeterNumber(tariff: any) {
        return html`
            <div class="pt-2">
                <div class="d-flex flex-wrap mb-3" role="radiogroup"
                     aria-label="${TYPO3?.lang?.['form.configureTariff.delivery.switchMeterNumber.ariaLabel']}">
                    ${this.renderSwitchMeterNumberRadioOption(tariff, 'know-meter-number', 'know', true)}
                    ${this.renderSwitchMeterNumberRadioOption(tariff, 'share-meter-number', 'share')}
                </div>
            </div>`
    }

    private renderElectricityCounter(tariff: any) {
        return html`
            <div class="pt-2-375">
                <h4>Tarif: ${tariff.data.tariff.title}</h4>
            </div>
            ${this.renderSwitchMeterNumber(tariff)}
            ${tariff.deliveryData.selectedSwitchMeterNumber !== 'share-meter-number' ? html`
                <div class="d-flex flex-column flex-md-row align-items-md-center justify-start">
                    <label for="sws-rateCalculator-electricity-meter"
                           class="form-label font-20 fw-bold mb-3 pe-3">
                        ${TYPO3?.lang?.['form.configureTariff.delivery.electricityMeter.label']}
                    </label>

                    <a href="#" class="font-16 mb-3 text-black" data-bs-toggle="modal"
                       data-bs-target="#modal-electricity-meter-info">${TYPO3?.lang?.['form.configureTariff.delivery.allMeter.modalLabel']}</a>
                </div>
                <div id="feedback-electricity" class=" mb-3 ">
                    <div class="input-group input-group-icon-el">
                        <div class="input-group-text border-0"><i class="icon-haushaltszaehler-stromzaehler p-1"></i>
                        </div>
                        <input type="text" class="form-control border-start-0 border-0 p-3"
                               id="sws-rateCalculator-electricity-meter"
                               name="sws-rateCalculator-electricity-meter"
                               @input=${(e: Event) => this._updateDeliveryData(tariff.id, 'allMeterCounter', (e.target as HTMLInputElement).value)}
                               placeholder="${TYPO3?.lang?.['form.configureTariff.delivery.allMeter.placeholder']}"
                               aria-label="${TYPO3?.lang?.['form.configureTariff.delivery.allMeter.ariaLabel']}"
                        />
                    </div>
                    <div class="invalid-feedback"></div>
                </div>
                <div id="feedback-electro-malo">
                    <div class="input-group">
                        <input type="number" class="form-control p-3"
                               id="sws-rateCalculator-electricity-malo-number"
                               name="sws-rateCalculator-electricity-malo-number"
                               @input=${(e: Event) => this._updateDeliveryData(tariff.id, 'maloCounter', (e.target as HTMLInputElement).value)}
                               placeholder="${TYPO3?.lang?.['form.configureTariff.delivery.maloCounter.placeholder']}"
                               aria-label="${TYPO3?.lang?.['form.configureTariff.delivery.maloCounter.ariaLabel']}"
                        />
                    </div>
                    <div class="invalid-feedback"></div>
                </div>
            ` : html``}`
    }

    private renderHeatPumpCounter(tariff: any) {
        return html`
            <div class=" pt-2-375">
                <h4 class="mb-3">Tarif: ${tariff.data.tariff.title}</h4>
            </div>
            ${this.renderSwitchMeterNumber(tariff)}
            ${tariff.deliveryData.selectedSwitchMeterNumber !== 'share-meter-number' ? html`
                <div class="d-flex flex-column flex-md-row align-items-center">
                    <label for="sws-rateCalculator-heatpump-meter"
                           class="form-label font-20 fw-bold mb-3 pe-3">
                        ${TYPO3?.lang?.['form.configureTariff.delivery.electricityMeter.label']}
                    </label>

                    <a href="#" class="font-16 mb-3 text-black" data-bs-toggle="modal"
                       data-bs-target="#modal-electricity-meter-info">${TYPO3?.lang?.['form.configureTariff.delivery.allMeter.modalLabel']}</a>
                </div>
                <div id="feedback-heatPump" class="mb-3">
                    <div class="input-group input-group-icon-hp">
                        <div class="input-group-text border-0"><i
                                class="icon-haushaltszaehler-stromzaehler p-1"></i>
                        </div>
                        <input type="text" class="form-control border-start-0 border-0 p-3"
                               id="sws-rateCalculator-heatPump-meter"
                               name="sws-rateCalculator-heatPump-meter"
                               @input=${(e: Event) => this._updateDeliveryData(tariff.id, 'allMeterCounter', (e.target as HTMLInputElement).value)}
                               placeholder="${TYPO3?.lang?.['form.configureTariff.delivery.allMeter.placeholder']}"
                               aria-label="${TYPO3?.lang?.['form.configureTariff.delivery.allMeter.ariaLabel']}"
                        />
                    </div>
                    <div class="invalid-feedback"></div>

                </div>
                <div id="feedback-heat-malo">
                    <div class="input-group">
                        <input type="number" class="form-control p-3"
                               id="sws-rateCalculator-heatPump-malo-number"
                               name="sws-rateCalculator-heatPump-malo-number"
                               @input=${(e: Event) => this._updateDeliveryData(tariff.id, 'maloCounter', (e.target as HTMLInputElement).value)}
                               placeholder="${TYPO3?.lang?.['form.configureTariff.delivery.maloCounter.placeholder']}"
                               aria-label="${TYPO3?.lang?.['form.configureTariff.delivery.maloCounter.ariaLabel']}"
                        />
                    </div>
                    <div class="invalid-feedback"></div>
                </div>
            ` : html``}
        `
    }

    private renderGasCounter(tariff: any) {
        return html`
            <div class="mb-3 pt-2-375">
                <h4>Tarif: ${tariff.data.tariff.title}</h4>
            </div>
            ${this.renderSwitchMeterNumber(tariff)}
            ${tariff.deliveryData.selectedSwitchMeterNumber !== 'share-meter-number' ? html`
                <div class="d-flex flex-column flex-md-row align-items-center">
                    <label for="sws-rateCalculator-gas-meter"
                           class="form-label font-20 fw-bold mb-3 pe-3">
                        ${TYPO3?.lang?.['form.configureTariff.delivery.naturalGasMeter.label']}
                    </label>
                    <a href="#" class="font-16 mb-3 text-black" data-bs-toggle="modal"
                       data-bs-target="#modal-electricity-meter-info">${TYPO3?.lang?.['form.configureTariff.delivery.allMeter.modalLabel']}</a>
                </div>
                <div id="feedback-naturalGas" class="mb-3">
                    <div class="input-group input-group-icon-ng">
                        <div class="input-group-text border-0"><i class="icon-haushaltszaehler-stromzaehler p-1"></i>
                        </div>
                        <input type="text" class="form-control border-0 p-3"
                               id="sws-rateCalculator-gas-meter"
                               name="sws-rateCalculator-gas-meter"
                               @input=${(e: Event) => this._updateDeliveryData(tariff.id, 'allMeterCounter', (e.target as HTMLInputElement).value)}
                               placeholder="${TYPO3?.lang?.['form.configureTariff.delivery.allMeter.placeholder']}"
                               aria-label="${TYPO3?.lang?.['form.configureTariff.delivery.allMeter.ariaLabel']}"
                        />

                    </div>
                    <div class="invalid-feedback"></div>
                </div>
                <div id="feedback-gas-malo">
                    <div class="input-group">
                        <input type="number" class="form-control p-3"
                               id="sws-rateCalculator-naturalGas-malo-number"
                               name="sws-rateCalculator-naturalGas-malo-number"
                               @input=${(e: Event) => this._updateDeliveryData(tariff.id, 'maloCounter', (e.target as HTMLInputElement).value)}
                               placeholder="${TYPO3?.lang?.['form.configureTariff.delivery.maloCounter.placeholder']}"
                               aria-label="${TYPO3?.lang?.['form.configureTariff.delivery.maloCounter.ariaLabel']}"
                        /></div>
                    <div class="invalid-feedback"></div>
                </div>
            ` : html``}
        `
    }

    private renderElectricitySmartMeter(tariff: any) {
        const currentValue = tariff.deliveryData?.smartMeterOption || 'none';

        return html`
            <div class="d-flex pt-2-375 flex-column flex-md-row">
                <h2 class="h5 fw-bold font-20 mb-3 pe-3">
                    ${TYPO3?.lang?.['form.configureTariff.delivery.smartMeter.label']}</h2>
                <a href="https://www.stadtwerke-stuttgart.de/waerme-und-energieeffizienz/smartmeter/"
                   target="_blank"
                   rel="noopener noreferrer"
                   class="font-16 pb-2 text-black">${TYPO3?.lang?.['form.configureTariff.delivery.smartMeter.linkLabel']}</a>
            </div>

            <fieldset role="radiogroup"
                      aria-label="${TYPO3?.lang?.['form.configureTariff.delivery.smartMeter.label']}"
                      class="consumer-input-box feedback-border-smartMeter-${tariff.id}">

                <div class="form-check form-switch h-checkbox d-flex p-0 gap-2">
                    <div class="justify-content-between d-flex w-100 b-bot px-4 align-items-center">
                        <label class="form-check-label w-75 py-1-313" for="own-smart-meter-${tariff.id}">
                            ${TYPO3?.lang?.['form.configureTariff.delivery.smartMeter.own']}
                        </label>

                        <input
                                class="form-check-input form-check-toggle"
                                type="radio"
                                name="own-smart-meter-${tariff.id}"
                                id="own-smart-meter-${tariff.id}"
                                value="ownSmartMeter"
                                .checked=${currentValue === 'ownSmartMeter'}
                                @change=${() => this._updateDeliveryData(tariff.id, 'smartMeterOption', 'ownSmartMeter')}
                        >
                    </div>
                </div>

                <div class="form-check form-switch h-checkbox d-flex p-0 gap-2">
                    <div class="justify-content-between d-flex w-100 px-4 align-items-center">
                        <label class="form-check-label w-75 py-1-313" for="new-smart-meter-${tariff.id}">
                            ${TYPO3?.lang?.['form.configureTariff.delivery.smartMeter.buyNew']}
                            <strong>99,99 €</strong>
                        </label>

                        <input
                                class="form-check-input form-check-toggle"
                                type="radio"
                                name="new-smart-meter-${tariff.id}"
                                id="new-smart-meter-${tariff.id}"
                                value="newSmartMeter"
                                .checked=${currentValue === 'newSmartMeter'}
                                @change=${() => this._updateDeliveryData(tariff.id, 'smartMeterOption', 'newSmartMeter')}
                        >
                    </div>
                </div>
            </fieldset>
            <div class="invalid-feedback" id="termination-feedback-smartMeter-${tariff.id}"></div>
        `;
    }

    private renderSupplierChangeSection(tariff: any) {
        return html`
            <div class="pt-2-375">
                <div id="suplier-change-feedback">
                    <label class="form-label font-20 fw-bold mb-3"
                           for="sws-rateCalculator-supplier-change-supplier-${tariff.id}">
                        ${tariff.data.tariff.type === 0 ? html`
                            ${TYPO3?.lang?.['form.configureTariff.delivery.supplierChange.change.naturalGas.headline']}` : html`
                            ${TYPO3?.lang?.['form.configureTariff.delivery.supplierChange.change.electricity.headline']}`}
                    </label>
                    <input type="text" class="form-control p-3"
                           id="sws-rateCalculator-supplier-change-supplier-${tariff.id}"
                           name="sws-rateCalculator-supplier-change-supplier-${tariff.id}"
                           list="sws-rateCalculator-supplier-change-supplier-${tariff.id}-list"
                           aria-label="${TYPO3?.lang?.['form.configureTariff.delivery.supplierChange.change.ariaLabel']}"
                           placeholder="${TYPO3?.lang?.['form.configureTariff.delivery.supplierChange.change.placeholder']}"
                           @change=${(e: Event) => this._updateDeliveryData(tariff.id, 'previousSupplier', (e.target as HTMLInputElement).value)}
                           required
                    />
                    <datalist id="sws-rateCalculator-supplier-change-supplier-${tariff.id}-list">
                        ${this._getSuppliers(tariff.data.tariff.type, tariff.id)}
                    </datalist>
                    <div class="invalid-feedback"></div>
                </div>
            </div>

            <!-- Radiogroup: Wer kündigt? -->
            <fieldset class="mt-4 w-full consumer-input-box feedback-border-${tariff.id}" role="radiogroup"
                      aria-label="Kündigungsoption wählen">
                <!-- Option 1: Selbst gekündigt -->

                <div class="form-check form-switch h-checkbox d-flex p-0 gap-2">
                    <div class="justify-content-between d-flex w-100 px-4 align-items-center ${tariff.deliveryData?.selectedTerminationType !== 'self' ? 'b-bot' : ''}">
                        <label class="form-check-label w-75 font-16 py-1-313" for="termination-self-${tariff.id}">
                            ${TYPO3?.lang?.['form.configureTariff.delivery.supplierChange.change.resigned']}
                        </label>
                        <input class="form-check-input form-check-toggle"
                               type="radio"
                               role="switch"
                               id="termination-self-${tariff.id}"
                               name="terminationType-${tariff.id}"
                               value="self"
                               .checked=${tariff.deliveryData?.selectedTerminationType === 'self'}
                               @change=${() => {
                                   this._updateDeliveryData(tariff.id, 'selectedTerminationType', 'self');
                                   this._updateDeliveryData(tariff.id, 'alreadyResigned', false);
                                   this._updateDeliveryData(tariff.id, 'terminateContractBySWS', false);

                                   this.requestUpdate();
                                   this.updateComplete.then(() => {
                                       const container = this as HTMLElement;
                                       const continueButton = container.querySelector('#sws-nav-continue-user-data-button') as HTMLButtonElement;
                                   });
                               }}
                        >
                    </div>
                </div>

                ${tariff.deliveryData?.selectedTerminationType === 'self' ? html`
                    <div class="collapse show bg-light-dark" id="cancel-self-section-${tariff.id}">
                        <div class="form-floating mb-3 card card-body bg-light border">
                            <input type="date" class="form-control input-focus"
                                   id="resign-date-self-${tariff.id}"
                                   name="resign-date-self-${tariff.id}"
                                   min="${this._getMinDate()}"
                                   max="${this._getMaxDate()}"
                                   @input=${(e: Event) =>
                                           this._updateDeliveryData(tariff.id, 'dateToTerminateContract', (e.target as HTMLInputElement).value)
                                   } required>
                            <label for="resign-date-self-${tariff.id}" class="label-input">
                                ${TYPO3?.lang?.['form.configureTariff.delivery.supplierChange.resignSelfDate.label']}
                            </label>
                            <div class="invalid-feedback"></div>
                        </div>
                    </div>
                ` : ''}

                <!-- Option 2: SWS soll kündigen -->
                <div class="form-check form-switch h-checkbox d-flex p-0 gap-2">
                    <div class="justify-content-between d-flex w-100 px-4 align-items-center">
                        <label class="form-check-label w-75 py-1-313" for="termination-sws-${tariff.id}">
                            ${TYPO3?.lang?.['form.configureTariff.delivery.supplierChange.change.resigneViaStadtwerke']}
                        </label>
                        <input class="form-check-input form-check-toggle"
                               type="radio"
                               role="switch"
                               id="termination-sws-${tariff.id}"
                               name="terminationType-${tariff.id}"
                               value="sws"
                               .checked=${tariff.deliveryData?.selectedTerminationType === 'sws'}
                               @change=${() => {
                                   this._updateDeliveryData(tariff.id, 'selectedTerminationType', 'sws');
                                   this._updateDeliveryData(tariff.id, 'alreadyResigned', false);
                                   this._updateDeliveryData(tariff.id, 'terminateContractBySWS', true);
                               }} required
                        >

                    </div>
                </div>


            </fieldset>
            <div class="invalid-feedback" id="termination-feedback-${tariff.id}"></div>

        `;
    }

    private renderMoveSection() {
        return html`
            <div class="">
                <label for="sws-rateCalculator-electricity-on-key-handover"
                       class="form-label font-20 fw-bold mb-3 pe-3">
                    <h4>Wann ziehen Sie ein?</h4>
                </label>
                <div class="form-floating mb-3">
                    <input type="date" class="form-control input-focus"
                           id="sws-rateCalculator-electricity-on-key-handover"
                           name="sws-rateCalculator-electricity-on-key-handover"
                           placeholder="${TYPO3?.lang?.['form.configureTariff.delivery.supplierChange.move.electricityMeter.keyHandover.placeholder']}"
                           min="${this._getMinDate()}"
                           max="${this._getMaxDate()}"
                           @change=${(e: Event) => this._updateAllTariffs('dateChangeTariff', (e.target as HTMLInputElement).value)}
                    />
                    <label for="sws-rateCalculator-electricity-on-key-handover" class="label-input mt-3">
                        ${TYPO3?.lang?.['form.configureTariff.delivery.supplierChange.move.keyHandover.label']}
                    </label>
                    <div class="invalid-feedback"></div>
                </div>
            </div>
        `;
    }

    private renderMoveNextPage() {
        const isComplete = this._isFormComplete();
        return html`
            <div class="w-100 d-grid mt-5 d-flex flex-column flex-md-row justify-content-between align-items-center mb-4">
                <button
                        type="button"
                        id="sws-nav-continue-user-data-button"
                        class="btn btn-primary btn-continue d-flex justify-content-center align-items-center align-self-center order-md-2 mx-md-0 mb-3 mb-md-0 text-white"
                        @click=${() => this._handleNextStep()}
                >
                    ${TYPO3?.lang?.['btn.continue']}
                    <span class="input-group-text h-auto p-0 border-0 ms-3 icon-bg-trans">
                    <i class="icon-Pfeil-rechts icon-arrow-continue"></i>
                </span>
                </button>
                <div class="align-self-center">
                    <a href="#" id="sws-nav-back-choose-tariff-button"
                       class="btn btn-link btn-back text-black small h-auto order-md-1">${TYPO3?.lang?.['btn.back.chooseTariff']}</a>
                </div>
            </div>
        `;
    }

    private _getSuppliers(type: number, tariffId: string) {
        switch (type) {
            case 0: // Natural Gas
                return html`
                    ${this.gasSupplier.map(supplier => html`
                                <option value="${supplier.title}">${supplier.title}</option>
                            `
                    )}
                `;
            case 1: // Heat Pump
                return html`
                    ${this.electricitySupplier.map(supplier => html`
                                <option value="${supplier.title}">${supplier.title}</option>
                            `
                    )}
                `;
            case 2: // Electricity
                return html`
                    ${this.electricitySupplier.map(supplier => html`
                                <option value="${supplier.title}">${supplier.title}</option>
                            `
                    )}
                `;
        }
    }
}
